import React from 'react';

export default function Loading() {
  return <div style={{ backgroundColor: 'white', height: '100vh' }}>Loading</div>;
}
